import { cn } from '@kidshome/ui';

/**
 * A crisp inline flame glyph — the canonical "active streak" mark, replacing the bare 🔥 emoji (which
 * rendered inconsistently across platforms and couldn't be themed). Inherits `currentColor` (tint it warm
 * where it signals an active streak) and sizes to `1.1em`, scaling with its context — mirrors
 * {@link StarIcon} / {@link HeartIcon}.
 */
export function FlameIcon({ className }: { className?: string }): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={cn('inline-block size-[1.1em] shrink-0 align-[-0.15em]', className)}
    >
      <path d="M12 3c1 3-1 4-1 6a3 3 0 0 0 6 0c0-1 .6 1.4.6 3A5.6 5.6 0 1 1 6.5 11C7 8 10 7 12 3z" />
    </svg>
  );
}
